import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.link";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Markup from 'wfui-digital-core/es/Markup';
import StickyFooterContext from '../../context/StickyFooterContext';
import ChevronIcon from '../../icons/chevron/ChevronIcon';
import styles from './Link.less';

var Link = function Link(_ref) {
  var link = _ref.link;

  var _useContext = useContext(StickyFooterContext),
      navigate = _useContext.navigate,
      getString = _useContext.getString;

  var onClick = function onClick() {
    return navigate({
      link: link
    });
  };

  var registered = " ".concat(getString('global.registered.sign'), " ");
  var ariaLabel = (link.ariaLabel || link.label || '').replace('&reg;', registered).replace('®', registered);
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Block, {
    p: "b",
    layout: true,
    horizontal: true,
    center: true,
    el: "a",
    role: "link",
    tabIndex: "0",
    onClick: onClick,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(Block, {
    flex: true,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Markup, {
    content: link.label
  })), /*#__PURE__*/React.createElement(Block, {
    "aria-hidden": true,
    className: styles.icon
  }, /*#__PURE__*/React.createElement(ChevronIcon, null))));
};

export default Link;